import React from 'react'
import Layout from '../components/layout'
//import { Link } from 'gatsby'
import imgPaulina from '../images/paulina.jpg'
import imgCharlene from '../images/charlene.jpg'
import imgDiana from '../images/diana.jpg'
import imgJolina from '../images/jolina.jpg'
import imgSima from '../images/sima.jpg'
import imgLiz from '../images/liz.jpg'
import imgHelene from '../images/helene.jpg'
import imgKarolina from '../images/karolina.jpg'
import imgKulturwerke from '../images/kulturwerke-padded.jpeg'

import SEO from "../components/seo"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'

const Lineup = () => {
  return(
    <Layout pageInfo={{pageName: 'lineup'}} >
    <SEO title="Lineup" keywords={[`schueleraustausch`, `meetup`, `Line-up`]} />
      <section className='masthead min-vh-100'>
        <div className="text-left text-white">
          <div className="masthead-content">
            <div className="container">
              <div className='row'>
              <div className='col-md-6'>
                <h1>Das X-CHANGE Lineup 2020</h1>
                <p className='lead'>
                  Diese X-CHANGE-Botschafter*innen werden am 20. September beim Virtual X-CHANGE Meetup dabei sein.
                </p>
                <p>
                  Klicke jetzt durch die YouTube- und Instagram Profile der Teilnehmer*innen und überlege dir Fragen, die du ihnen zum Auslandsjahr stellen möchtest.
                </p>
                <p>
                  Wir werden versuchen deine Fragen beim Virtual X-Change Meetup live zu beantworten.
                </p>
                <p>
                  Wir freuen uns auf dich!
                </p>
              </div>
              <div className='col-md-6'>
              <div className='row'>
                  <div className='media col-12 lineup rounded shadow'>
                    <img src={imgPaulina} alt='Paulina' width='120' height='120'  className='rounded-circle'/>
                    <div className='media-body'>
                      <h5 className='mt-0'>Paulina</h5>
                      <p>
                        <a href="https://www.schueleraustausch.net/ratgeber/x-change-botschafter/text/paulina-schueleraustausch-usa-south-carolina">
                          Paulinas Profil
                        </a><br />
                        <FontAwesomeIcon icon={faYoutube} className='text-white'/>&nbsp;
                        <a href="https://www.youtube.com/channel/UCCTMCLSVkv-iucsE7tl6RaA" target="_blank" rel="noopener noreferrer nofollow">
                          Paulinas Channel
                        </a><br />
                        <FontAwesomeIcon icon={faInstagram} className='text-white'/>&nbsp;
                        <a href="https://www.instagram.com/paulinaclaire" target="_blank" rel="noopener noreferrer nofollow">
                          @paulinaclaire
                        </a>
                      </p>
                    </div>
                  </div>



                  <div className='media col-12 lineup rounded shadow'>
                    <img src={imgJolina} alt='Jolina' width='120' height='120' className='rounded-circle' />
                    <div className='media-body'>
                      <h5 className='mt-0'>Jolina</h5>
                      <p>
                        <a href="https://www.schueleraustausch.net/ratgeber/x-change-botschafter/text/jolina-schueleraustausch-australien-adelaide">
                          Jolinas Profil
                        </a><br />
                        <FontAwesomeIcon icon={faYoutube} className='text-white'/>&nbsp;
                        <a href="https://www.youtube.com/channel/UCUYuZNXWs-otH4hIbmse0CA" target="_blank" rel="noopener noreferrer nofollow">
                          Jolinas Channel
                        </a><br />
                        <FontAwesomeIcon icon={faInstagram} className='text-white'/>&nbsp;
                        <a href="https://www.instagram.com/jolinainaustralia" target="_blank" rel="noopener noreferrer nofollow">
                          @jolinainaustralia
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className='media col-12  lineup rounded shadow'>
                    <img src={imgCharlene} alt='Charlene' width='120' height='120'  className='rounded-circle'/>
                    <div className='media-body'>
                      <h5 className='mt-0'>Charlene</h5>
                      <p>
                        <FontAwesomeIcon icon={faYoutube} className='text-white'/>&nbsp;
                        <a href="https://www.youtube.com/channel/UCaNOZQvUV0MIdflFCZ9HGIQ" target="_blank" rel="noopener noreferrer nofollow">
                          Charlenes Channel
                        </a><br />
                        <FontAwesomeIcon icon={faInstagram} className='text-white'/>&nbsp;
                        <a href="https://www.instagram.com/charlene_sabrina" target="_blank" rel="noopener noreferrer nofollow">
                          @charlene_sabrina
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className='media col-12 lineup rounded shadow'>
                    <img src={imgDiana} alt='Paulina' width='120' height='120'  className='rounded-circle'/>
                    <div className='media-body'>
                      <h5 className='mt-0'>Diana</h5>
                      <p>
                        <FontAwesomeIcon icon={faYoutube} className='text-white'/>&nbsp;
                        <a href="https://www.youtube.com/channel/UCVuys8EmqjwR6ktXWNOLvyA" target="_blank" rel="noopener noreferrer nofollow">
                          Dianas Channel
                        </a><br />
                        <FontAwesomeIcon icon={faInstagram} className='text-white'/>&nbsp;
                        <a href="https://www.instagram.com/dianadaytona_" target="_blank" rel="noopener noreferrer nofollow">
                          @dianadaytona_
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className='media col-12 lineup rounded shadow'>
                    <img src={imgSima} alt='Sima' width='120' height='120'  className='rounded-circle'/>
                    <div className='media-body'>
                      <h5 className='mt-0'>Sima</h5>
                      <p>
                        <FontAwesomeIcon icon={faYoutube} className='text-white'/>&nbsp;
                        <a href="https://www.youtube.com/channel/UC9a2P9wZfzTwUaKYrXiysug" target="_blank" rel="noopener noreferrer nofollow">
                          Simas Channel
                        </a><br />
                        <FontAwesomeIcon icon={faInstagram} className='text-white'/>&nbsp;
                        <a href="https://www.instagram.com/simaaysu" target="_blank" rel="noopener noreferrer nofollow">
                          @simaaysu
                        </a>
                      </p>
                    </div>
                  </div>


                  <div className='media col-12 lineup rounded shadow'>
                    <img src={imgLiz} alt='Liz' width='120' height='120'  className='rounded-circle'/>
                    <div className='media-body'>
                      <h5 className='mt-0'>Liz</h5>
                      <p>
                        <FontAwesomeIcon icon={faYoutube} className='text-white'/>&nbsp;
                        <a href="https://www.youtube.com/channel/UCRwaAmm0ijxQjaK0TEUUcHw" target="_blank" rel="noopener noreferrer nofollow">
                          Liz Channel
                        </a><br />
                        <FontAwesomeIcon icon={faInstagram} className='text-white'/>&nbsp;
                        <a href="https://www.instagram.com/itslizkatherine" target="_blank" rel="noopener noreferrer nofollow">
                          @itslizkatherine
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className='media col-12 lineup rounded shadow'>
                    <img src={imgKarolina} alt='Karolina' width='120' height='120' className='rounded-circle' />
                    <div className='media-body'>
                      <h5 className='mt-0'>Karolina</h5>
                      <p>
                        <FontAwesomeIcon icon={faYoutube} className='text-white'/>&nbsp;
                        <a href="https://www.youtube.com/c/KarolinasLife/featured" target="_blank" rel="noopener noreferrer nofollow">
                          Karolinas Channel
                        </a><br />
                        <FontAwesomeIcon icon={faInstagram} className='text-white'/>&nbsp;
                        <a href="https://www.instagram.com/karoxannax/" target="_blank" rel="noopener noreferrer nofollow">
                          @karoxannax
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className='media col-12 lineup rounded shadow'>
                    <img src={imgHelene} alt='Helene' width='120' height='120' className='rounded-circle' />
                    <div className='media-body'>
                      <h5 className='mt-0'>Helene</h5>
                      <p>
                        <FontAwesomeIcon icon={faYoutube} className='text-white'/>&nbsp;
                        <a href="https://www.youtube.com/channel/UCRd91SdnQruzdGhQN-9EmkQ" target="_blank" rel="noopener noreferrer nofollow">
                          Helenes Channel
                        </a><br />
                        <FontAwesomeIcon icon={faInstagram} className='text-white'/>&nbsp;
                        <a href="https://www.instagram.com/littleworldoflene/?hl=de" target="_blank" rel="noopener noreferrer nofollow">
                          @littleworldoflene
                        </a>
                      </p>
                    </div>
                  </div>


                  <div className='media col-12 lineup rounded shadow'>
                    <img src={imgKulturwerke} alt='Logo Kulturwerke Deutschland' width='120' height='120' className='rounded-circle' />
                    <div className='media-body'>
                      <h5 className='mt-0'>Kulturwerke Deutschland</h5>
                      <p>
                        Kulturwerke Deutschland Sprachreisen GmbH
                      </p>
                    </div>
                  </div>

              </div>
              </div>
              </div>

            </div>
          </div>
          <div className="bg-circle-1 bg-circle"></div>
          <div className="bg-circle-2 bg-circle"></div>
          <div className="bg-circle-3 bg-circle"></div>
          <div className="bg-circle-4 bg-circle"></div>
        </div>
      </section>
    </Layout>
  )
}

export default Lineup
